import React, { Component } from "react";
import './Page404.css';

class PageNotFound extends Component {
    render() {
        return (
            <div className="page404">
                <div className="container Image404"></div>
            </div>
        );
    }
}

export default PageNotFound;
